import { File, FileDoc, FileImage, FilePdf, FileXls, Folder, type Icon } from '@phosphor-icons/react';
import { dateiArt, type DateiArt } from '../../../../lib/dokumente/aktenschrank';
import { hauptordnerAus, ORDNER_FARBE } from '../../../../lib/dokumente/ordner';

const ART: Record<DateiArt, { icon: Icon; fg: string; bg: string }> = {
  pdf: { icon: FilePdf, fg: 'var(--bad)', bg: 'var(--bad-soft)' },
  bild: { icon: FileImage, fg: 'var(--info)', bg: 'var(--info-soft)' },
  word: { icon: FileDoc, fg: 'var(--info)', bg: 'var(--info-soft)' },
  excel: { icon: FileXls, fg: 'var(--ok)', bg: 'var(--ok-soft)' },
  sonst: { icon: File, fg: 'var(--ink2)', bg: 'var(--fill2)' },
};

/** Icon und Farben einer Datei nach Typ. */
export const dateiDarstellung = (name: string, mime?: string | null) => ART[dateiArt(name, mime)];

/** Farbe eines Ordners nach seinem Hauptordner (00–06, 99), sonst Akzent. */
export function ordnerFarbe(pfadOderName: string): { fg: string; bg: string } {
  const k = hauptordnerAus(pfadOderName);
  return k ? ORDNER_FARBE[k] : { fg: 'var(--acc)', bg: 'var(--acc-soft)' };
}

export const OrdnerIcon = Folder;

/** Nur echte, harmlose Typen als Vorschau (kein SVG/HTML – XSS-Schutz wie im alten Aktenschrank). */
export function vorschauArt(mime: string | null | undefined): 'bild' | 'pdf' | null {
  const typ = (mime ?? '').toLowerCase().split(';')[0].trim();
  if (/^image\/(png|jpe?g|gif|webp|bmp|tiff?)$/.test(typ)) return 'bild';
  if (typ === 'application/pdf') return 'pdf';
  return null;
}

export const driveOrdnerUrl = (id: string) => `https://drive.google.com/drive/folders/${id}`;
export const deDatumZeit = (iso?: string | null) => (iso ? new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');
